import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'spb-primary-bullet',
  templateUrl: './primary-bullet.component.html',
})
export class PrimaryBulletComponent implements OnInit {
  @HostBinding('class.spb-primary-bullet') hostBaseClass = true;
  @Input() bulletColor: string;
  @Input() bulletSize: string;

  constructor() {
  }

  ngOnInit() {
  }

}
